import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export type PaymentRecordsStatusesStatistics = {
  totalAmount: number
  paidAmount: number
  pendingAmount: number
  refundedAmount: number
  overpaidAmount: number
  balanceDueDate: string | null
}

export function getPaymentRecordsStatusesStatistics(input: {
  enrollmentId: number
}): Promise<PaymentRecordsStatusesStatistics> {
  return restApiClient
    .url(
      constructApiUrl(API.enrollments.getPaymentRecordsStatusesStatistics.url, {
        id: input.enrollmentId
      })
    )
    .get<PaymentRecordsStatusesStatistics>()
}
